import translations from '../../../../lang/translations';

function toggleStateCity(content, show) {
    var stateParent = content.find('select[name="state_id"]').parent();
    var cityParent = content.find('select[name="city_id"]').parent();

    stateParent.toggleClass('hidden', !show);
    cityParent.toggleClass('hidden', !show);

    stateParent.attr('hidden', !show);
    cityParent.attr('hidden', !show);
}

export function setupSelectCountryStateCity(container) {
    const selectCountry = container.find('select[name="country_id"]');
    const selectState = container.find('select[name="state_id"]');
    const selectCity = container.find('select[name="city_id"]');

    selectCountry.on('change', function () {
        var v = $(this).val();

        selectState.empty();
        selectCity.empty();

        if (!v) {
            toggleStateCity(container, false);
            return;
        }

        $.get(routeLocale('/api/contato/estados/' + v)).then(function (rs) {
            selectState.append(new Option(translations[window.currentLocale()].select_state, ''));
            selectCity.append(new Option(translations[window.currentLocale()].select_city, ''));
            $.each(rs, function (index, item) {
                selectState.append(new Option(index, item));
            });

            toggleStateCity(container, rs.length != 0);
        });
    });

    selectState.on('change', function () {
        var v = $(this).val();
        selectCity.empty();

        if (!v) {
            return;
        }

        $.get(routeLocale('/api/contato/cidades/' + v)).then(function (rs) {
            selectCity.append(new Option(translations[window.currentLocale()].select_city, ''));
            $.each(rs, function (index, item) {
                selectCity.append(new Option(index, item));
            });
        });
    });

    selectCountry.trigger('change');
}
